import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { Box } from "@mui/material";
import { COMPANY_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import SubmitBtn from "./components/Buttons/SubmitBtn";
import InputField from "./components/Inputs/InputField";

import { validationSchema } from "./components/ValidationSchema/ValidationSchema";
import Status from "./components/Buttons/Status";
import Contract from "./components/SelectCollection/Contract";

const CompanyModal = () => {
  const dispatch = useDispatch();
  const { companyModalData: modalData } = useSelector(
    (state) => state.companyModal,
  );

  const ValidationSchema = validationSchema(modalData);

  // formik
  const formik = useFormik({
    initialValues: {
      companyName: modalData?.companyName || "",
      directorFullName: modalData?.directorFullName || "",
      companyVoen: modalData?.companyVoen || "",
      bankName: modalData?.bankName || "",
      correspondentAccount: modalData?.correspondentAccount || "",
      bankVoen: modalData?.bankVoen || "",
      bankCode: modalData?.bankCode || "",
      swift: modalData?.swift || "",
      settlementAccount: modalData?.settlementAccount || "",
      payment: modalData?.payment || "",
      paymentDate: modalData?.paymentDate || "",
      contractStartDate: modalData?.contractStartDate || "",
      contractEndDate: modalData?.contractEndDate || "",
      isPaid: modalData?.isPaid || "",
      isActive: modalData?.isActive || "",
    },
    validationSchema: ValidationSchema,
    validateOnMount: true,
  });

  const setInputValue = useCallback(
    (key, value) =>
      formik.setValues({
        ...formik.values,
        [key]: value,
      }),
    [formik],
  );

  const updateModalState = (keyName, value) => {
    // setInputValue(keyName, value);
    // console.log(value);
    dispatch({
      type: COMPANY_MODAL_ACTION_TYPE.GET_COMPANY_MODAL,
      payload: {
        data: {
          ...modalData,
          [keyName]: value,
        },
        openModal: true,
      },
    });
  };
  const closeModal = () => {
    dispatch({
      type: COMPANY_MODAL_ACTION_TYPE.GET_COMPANY_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  console.log(modalData);

  return (
    <div className="create-update-modal-con teacher-modal">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>{modalData?._id ? "Şirkəti yenilə" : "Şirkət əlavə et"}</h2>
          <CloseBtn onClick={closeModal} />
        </div>

        <Box
          onSubmit={(e) => e.preventDefault()}
          component="form"
          sx={{
            width: 500,
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="create-update-modal-form">
            <InputField
              inputName="companyName"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />
            <InputField
              inputName="directorFullName"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <InputField
              inputName="companyVoen"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <InputField
              inputName="bankName"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <InputField
              inputName="correspondentAccount"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <InputField
              inputName="bankVoen"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <InputField
              inputName="bankCode"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <InputField
              inputName="swift"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <InputField
              inputName="settlementAccount"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />{" "}
            <Contract
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />
            <div className="input-couples">
              <InputField
                inputName="contractStartDate"
                formik={formik}
                setInputValue={setInputValue}
                modalData={modalData}
                updateModalState={updateModalState}
              />{" "}
              <InputField
                inputName="contractEndDate"
                formik={formik}
                setInputValue={setInputValue}
                modalData={modalData}
                updateModalState={updateModalState}
              />
              <InputField
                inputName="payment"
                formik={formik}
                setInputValue={setInputValue}
                modalData={modalData}
                updateModalState={updateModalState}
              />{" "}
              <InputField
                inputName="paymentDate"
                formik={formik}
                setInputValue={setInputValue}
                modalData={modalData}
                updateModalState={updateModalState}
              />
            </div>
          </div>
        </Box>

        {modalData?._id ? (
          <div className="create-update-modal-btn-con">
            <Status modalData={modalData} updateModalState={updateModalState} />
            <SubmitBtn
              formik={formik}
              modalData={modalData}
              funcType="update"
            />
          </div>
        ) : (
          // </div>
          <SubmitBtn formik={formik} modalData={modalData} funcType="create" />
        )}
      </div>
    </div>
  );
};

export default CompanyModal;
